import { inject } from '@angular/core';

import { OutcomeReadySignalState } from '../store';
import { OUTCOME_READY_DEFAULT_REQUEST_PARAMS } from '@data-access/dash-board';

/**
 * Route resolver that preflights the dashboard "Outcomes ready" payload.
 *
 * Triggers the fetch only when the slice has never been loaded, so navigating
 * back to the dashboard reuses the cached payload.
 *
 * @returns True once the payload is loaded and no request is in-flight.
 */
export const outcomeReadyResolver = () => {
  const _outcomeReadySignalState = inject(OutcomeReadySignalState);
  const _outcomeReadyData = _outcomeReadySignalState.$data();
  if (!_outcomeReadyData) {
    _outcomeReadySignalState.getOutcomesReady({
      requestQueryParams: OUTCOME_READY_DEFAULT_REQUEST_PARAMS,
      useMock: false,
    });
  }

  return (
    !_outcomeReadySignalState.$isLoading() && !!_outcomeReadySignalState.$data()
  );
};
